import React from "react";
import { Star } from "@phosphor-icons/react";

export default function Stars({ value = 0, onChange, size = 28, testid = "stars" }) {
  const readOnly = !onChange;
  return (
    <div className="flex items-center gap-1" data-testid={testid}>
      {[1, 2, 3, 4, 5].map((n) => {
        const active = n <= (value || 0);
        return (
          <button
            key={n}
            type="button"
            onClick={readOnly ? undefined : () => onChange(n === value ? 0 : n)}
            className={`star-btn ${readOnly ? "cursor-default" : "cursor-pointer"}`}
            data-testid={`${testid}-${n}`}
            aria-label={`${n} star`}
          >
            <Star
              size={size}
              weight={active ? "fill" : "regular"}
              color={active ? "#FFD166" : "#404040"}
            />
          </button>
        );
      })}
    </div>
  );
}
